export const checkIsPhysician = (item) => {
  return item.orchid_pro_type.type === "physician";
};

export const checkIsPsychologist = (item) => {
  return item.orchid_pro_type.type === "psychologist";
};

export const checkIsSocialWorker = (item) => {
  return item.orchid_pro_type.type === "social worker";
};

export const checkIsTherapist = (item) => {
  return item.orchid_pro_type.type === "therapist";
};
